<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="customerId == 154 ? rules1 : rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="头像：" prop="avatar" style="margin-bottom: 0">
        <div class="form_item_box">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            :action="action"
            :show-file-list="false"
            accept=".jpg,.gif,.png,.jpeg"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :headers="{ Authorization: token }"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="姓名：" prop="nickName">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.nickName"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="手机号：" prop="phonenumber">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.phonenumber"
            type="text"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.password"
            type="password"
            show-password
            autocomplete="new-password"
            placeholder="更新账户时，如不需要修改密码，请留空"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="工号：" prop="jobnumber">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.jobnumber"
            type="text"
            placeholder="请输入工号"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.email"
            type="text"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item label="工号：" prop="email">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.email"
            type="text"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </div>
      </el-form-item> -->
      <el-form-item label="核算科室：" prop="checkDeskId">
        <div class="form_item_box">
          <!-- <el-select
            v-model="ruleForm.checkDeskId"
            placeholder="请选择"
            @change="getName"
            clearable
          >
            <el-option
              v-for="item in checkDeskList"
              :key="item.id"
              :label="item.checkDeskName"
              v-model="item.id"
              :disabled="item.isParent"
            >
            </el-option>
          </el-select> -->
          <el-cascader
            filterable
            v-model="ruleForm.checkDeskId"
            :options="checkDeskList"
            :props="checkDeskKey"
            clearable
            @change="getName"
          ></el-cascader>
        </div>
      </el-form-item>
      <el-form-item label="科室选择：" prop="deskId">
        <div class="form_item_box">
          <el-cascader
            filterable
            v-model="ruleForm.deskId"
            ref="cascaderDesk"
            :options="branchList"
            :props="cascaderKey"
            clearable
            @change="branchName"
          ></el-cascader>
        </div>
      </el-form-item>
      <el-form-item label="楼宇：" prop="building">
        <div class="form_item_box">
          <el-select
            v-model="ruleForm.building"
            placeholder="请选择"
            @change="selectBuilding"
            clearable
          >
            <el-option
              v-for="item in buildingList"
              :key="item.id"
              :label="item.buildingName"
              v-model="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="楼层：" prop="floor">
        <div class="form_item_box">
          <el-select v-model="ruleForm.floor" placeholder="请选择" clearable>
            <el-option
              v-for="item in floorList"
              :key="item.id"
              :label="item.floorName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="房间号：" prop="room">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.room"
            placeholder="请输入房间号"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="科室电话：" prop="moblie">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.moblie"
            placeholder="请输入科室电话"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item label="角色设置：" prop="makeMain">
                <div class="form_item_box">
                    <el-select v-model="ruleForm.makeMain" placeholder="请选择" clearable>
                        <el-option label="普通员工" :value="2"></el-option>
                        <el-option label="管理" :value="3"></el-option>
                    </el-select>
                </div>
            </el-form-item> -->
      <el-form-item label="员工类型：" prop="mainType">
        <div class="form_item_box">
          <el-select v-model="ruleForm.mainType" placeholder="请选择" clearable>
            <el-option label="主管" :value="2"></el-option>
            <el-option label="技术人员" :value="1"></el-option>
            <el-option label="用户" :value="3"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        label="系统权限："
        v-if="ruleForm.mainType != 3"
        prop="roleIds"
      >
        <div class="form_item_box">
          <el-select
            v-model="ruleForm.roleIds"
            multiple
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in permissionList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        label="员工上级："
        prop="parentId"
        v-show="ruleForm.mainType == 1"
      >
        <div class="form_item_box">
          <el-select v-model="ruleForm.parentId" placeholder="请选择" clearable>
            <el-option
              :label="item.nickName"
              :value="item.userId"
              v-for="item in memberSuperiorsList"
              :key="item.userId"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <!-- <el-form-item label="班次：" prop="classesId">
                <div class="form_item_box">
                    <el-select v-model="ruleForm.classesId" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.id" v-for=" item in classesList "
                            :key="item.id"></el-option>
                    </el-select>
                </div>
            </el-form-item> -->
      <el-form-item
        label="工单类型："
        v-if="ruleForm.mainType != 3"
        prop="type"
      >
        <div class="form_item_box">
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择"
            multiple
            clearable
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in workTypeList"
              :key="item.id"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="性别：" prop="sex">
        <div class="form_item_box">
          <el-select v-model="ruleForm.sex" placeholder="请选择性别" clearable>
            <el-option label="男" :value="0"></el-option>
            <el-option label="女" :value="1"></el-option>
            <el-option label="未知" :value="2"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <!--  v-show="this.isAdminCheck" -->
      <el-form-item label="会议权限：" prop="sex">
        <div class="form_item_box">
          <el-select
            v-model="ruleForm.isMeetingCheck"
            placeholder="请选择权限"
            clearable
          >
            <el-option label="不需要审核" :value="1"></el-option>
            <el-option label="需要审核" :value="2"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <div class="form_item_box">
          <el-input
            v-model="ruleForm.remark"
            placeholder="请输入备注"
            clearable
            type="textarea"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <div class="form_item_box">
          <el-switch
            v-model="ruleForm.status"
            :active-value="0"
            :inactive-value="1"
          >
          </el-switch>
        </div>
      </el-form-item>
      <el-form-item>
        <div
          style="
            width: 100%;
            margin-left: -50px;
            display: flex;
            justify-content: center;
          "
        >
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 100px"
            >确定</el-button
          >
          <el-button @click="resetForm()" style="width: 100px">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import config from "../../../config";
export default {
  props: ["memberModal", "node", "type"],
  data() {
    return {
      customerId: window.localStorage.getItem("customerId"),
      ruleForm: {
        avatar: "",
        nickName: "",
        userName: "",
        phonenumber: "",
        password: "",
        deskId: "",
        checkDeskId: "",
        checkDeskName: "",
        jobnumber: "",
        moblie: "",
        makeMain: 3,
        parentId: "",
        mainType: "",
        type: [],
        sex: "",
        roleIds: [],
        remark: "",
        // classesId: "",
        status: 0,
        building: "",
        floor: "",
        room: "",
        email: "",
        isMeetingCheck: 2,
      },
      isAdminCheck: true,
      buildingList: [],
      floorList: [],
      branchList: [],
      checkDeskList: [],
      cascaderKey: {
        value: "id",
        label: "deskName",
        checkStrictly: true,
        emitPath: false,
      },
      checkDeskKey: {
        value: "id",
        label: "checkDeskName",
        checkStrictly: true,
        emitPath: false,
      },
      workTypeList: [],
      memberSuperiorsList: [],
      permissionList: [],
      classesList: [],
      memberType: "",
      rules: {
        nickName: [
          { required: true, message: "姓名 不能为空！", trigger: "blur" },
        ],
        phonenumber: [
          { required: true, message: "手机号 不能为空！", trigger: "blur" },
        ],
        makeMain: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        mainType: [
          { required: true, message: "员工类型不能为空！", trigger: "change" },
        ],
      },
      rules1: {
        nickName: [
          { required: true, message: "姓名 不能为空！", trigger: "blur" },
        ],
        phonenumber: [
          { required: true, message: "手机号 不能为空！", trigger: "blur" },
        ],
        makeMain: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        mainType: [
          { required: true, message: "员工类型不能为空！", trigger: "change" },
        ],
        checkDeskId: [
          { required: true, message: "核算科室不能为空！", trigger: "change" },
        ],
      },
      token: window.localStorage.getItem("token") || "",
      imageUrl: "",
      action: config.API_HOST + "/admin/common/upload",
    };
  },
  created() {
    this.getCheckDeskList();
    this.getBranch();
    this.getWorkType();
    this.getMemberSuperiors();
    this.getPermissionList();
    this.getClasses();
    this.getBuilding();
    this.memberType = "add";
    if (this.node && this.type == "edit") {
      this.getMemberInfo();
      this.memberType = "edit";
    }
  },
  methods: {
    getName(e) {
      let list = this.checkDeskList;
      for (let i = 0; i < list.length; i++) {
        const item = list[i].children;
        if (item && item.length > 0) {
          item.forEach((child) => {
            if (e == child.id) {
              this.ruleForm.checkDeskName = child.checkDeskName;
            }
          });
        }
      }
    },
    async getMemberInfo() {
      let res = await $utils.api.load(
        `/admin/system/user/${this.node.id}`,
        {},
        "get"
      );
      if (res.code == 200) {
        this.imageUrl = config.IMAGE_HOST + res.data.avatar;
        this.ruleForm.avatar = res.data.avatar;
        this.ruleForm.nickName = res.data.nickName;
        this.ruleForm.phonenumber = res.data.phonenumber;
        this.ruleForm.email = res.data.email;
        this.ruleForm.deskId = res.data.deskId;
        this.ruleForm.checkDeskId = res.data.checkDeskId;
        this.ruleForm.checkDeskName = res.data.checkDeskName;
        this.ruleForm.moblie = res.data.moblie;
        this.ruleForm.isMeetingCheck = res.data.isMeetingCheck;
        this.ruleForm.jobnumber = res.data.jobnumber;
        if (res.data.userAllType == "2,3") {
          this.ruleForm.makeMain = 2;
        } else if (
          res.data.userAllType == "1,2,3" ||
          res.data.userAllType == "1,3"
        ) {
          this.ruleForm.makeMain = 3;
        }
        /*  if (res.data.isAdmin === 1) {
          this.isAdminCheck = false;
        } else {
          this.isAdminCheck = true;
        } */
        this.ruleForm.mainType = res.data.mainType == 0 ? 2 : res.data.mainType;
        if (res.data.type) {
          res.data.type.split(",").forEach((item) => {
            this.ruleForm.type.push(parseInt(item));
          });
        }
        this.ruleForm.sex = res.data.sex
          ? parseInt(res.data.sex)
          : res.data.sex;
        this.ruleForm.roleIds = res.roleIds;
        this.ruleForm.remark = res.data.remark;
        this.ruleForm.status = parseInt(res.data.status);
        this.ruleForm.parentId =
          res.data.parentId == 0 ? "" : res.data.parentId;
        if (res.data.building) {
          this.ruleForm.building = parseInt(res.data.building);
          this.getFloor(this.ruleForm.building);
          if (res.data.floor) {
            this.ruleForm.floor = parseInt(res.data.floor);
          }
        }
        this.ruleForm.room = res.data.room;
        // this.ruleForm.classesId = res.data.classesId
      }
    },
    async getBranch() {
      let d = {};
      let res = await $utils.api.load("admin/system/desk/list", d, "get");
      if (res.code == 200) {
        this.branchList = res.rows;
      }
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        let data = res.rows;
        if (data && data.length > 0) {
          const processedRows = data.map((item) => ({
            ...item,
            disabled: true,
          }));
          const updatedResponseData = {
            rows: processedRows,
          };
          this.checkDeskList = updatedResponseData.rows;
        } else {
          this.checkDeskList = [];
        }
        /* if (data && data.length > 0) {
          data.forEach((item) => {
            if (item.children && item.children.length > 0) {
              item.children.forEach((child) => {
                result.push({
                  id: child.id,
                  checkDeskName: `${item.checkDeskName}-${child.checkDeskName}`,
                  isParent: child.isParent == 1 ? true : false,
                });
              });
            } else {
              result.push({
                id: item.id,
                checkDeskName: item.checkDeskName,
                isParent: item.isParent == 1 ? true : false,
              });
            }
          });
        } */
      }
    },
    async getWorkType() {
      let d = {};
      let res = await $utils.api.load("admin/system/workType/list", d, "get");
      if (res.code == 200) {
        this.workTypeList = res.rows;
      }
    },
    async getMemberSuperiors() {
      let d = {};
      let res = await $utils.api.load(
        "admin/system/maiUser/selectParentList",
        d,
        "get"
      );
      if (res.code == 200) {
        this.memberSuperiorsList = res.rows;
      }
    },
    async getPermissionList() {
      let d = {};
      let res = await $utils.api.load(
        "admin/system/role/optionselect",
        d,
        "get"
      );
      if (res.code == 200) {
        this.permissionList = res.data;
      }
    },
    branchName(e) {
      let phone = this.$refs.cascaderDesk.getCheckedNodes()[0].data.phone;
      this.ruleForm.moblie = phone;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.email) {
            let szReg =
              /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
            let bChk = szReg.test(this.ruleForm.email);
            if (!bChk) {
              return $utils.toast.error("邮箱格式错误！");
            }
          }
          if (this.memberType == "add") {
            let passwordReg = /^(?=.*[a-zA-Z])(?=.*\d).{6,32}$/;
            let passwordChk = passwordReg.test(this.ruleForm.password);
            if (!passwordChk) {
              return $utils.toast.error(
                "密码至少包含字母，数字，且不少于6位，不大于32位！"
              );
            }
          }
          if (this.ruleForm.mainType == 3) {
            this.ruleForm.type = [];
          }
          if (this.ruleForm.type.length > 0) {
            this.ruleForm.type = this.ruleForm.type.join(",");
          } else if (
            this.ruleForm.type.length == 0 &&
            this.ruleForm.makeMain == 3
          ) {
            this.ruleForm.type = "";
            this.ruleForm.makeMain = 1;
          } else {
            this.ruleForm.type = "";
          }
          if (this.memberType == "edit") {
            this.ruleForm.userId = this.node.id;
          }
          $utils.api
            .load(
              "admin/system/user",
              this.ruleForm,
              `${this.memberType == "edit" ? "put" : "post"}`
            )
            .then((res) => {
              if (res.code == 200) {
                $utils.toast.success(
                  this.memberType == "edit" ? "修改成功" : "新增成功"
                );
                this.$emit("memberModal");
              } else {
                if (this.ruleForm.type) {
                  let arr = [];
                  this.ruleForm.type = this.ruleForm.type.split(",");
                  this.ruleForm.type.forEach((item) => {
                    arr.push(parseInt(item));
                  });
                  this.ruleForm.type = arr;
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$Modal.remove();
      // this.$emit("memberModal");
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.ruleForm.avatar = res.url;
      }
    },
    beforeAvatarUpload(file) {
      let isImg = true;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isJPEG && !isPNG && !isGIF) {
        this.$message.error("上传头像图片只能是 JPG,JPEG,PNG,GIF 格式!");
        isImg = false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isImg && isLt2M;
    },
    async getClasses() {
      let d = {};
      let res = await $utils.api.load("admin/system/classes/list", d, "get");
      if (res.code == 200) {
        this.classesList = res.rows;
      }
    },
    async getBuilding() {
      let d = {};
      let res = await $utils.api.load("admin/system/building/list", d, "get");
      if (res.code == 200) {
        this.buildingList = res.rows;
      }
    },
    async getFloor(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("admin/system/floor/list", d, "get");
      if (res.code == 200) {
        this.floorList = res.rows;
      }
    },
    selectBuilding(e) {
      this.getFloor(e);
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-cascader,
.el-select {
  width: 100%;
}
</style>
